module.exports = __webpack_public_path__ + "img/11.e6607ac2.png";